// test2259
(2259 && 0);
